import React from 'react';

const CURL_DEFAULTS = {
    versionNumber : '3.1',
    oqlClause : 'totals.totalQuantity>2999'
};

const CURL_OPTIONAL = {
    oqlClause : true,
    limit : true ,
    offset : true,
};

class HighlightedCurl extends React.Component{
    constructor(props){ super(props);
        this.state = { html : '' , wait : props.wait };
    }

    highlightHtml( template ){
        let html = template;

        // Highlight the query string.
        html = html.replace(/(\?\S+)\s/, function (match) {
            // Highlight the query string parameters.
            return match.replace(/(\w+)=/g,
                "<span class='entity-name'>$1</span><span class='curl-assignment'>=</span>");
        });
        // Highlight values in quotes.
        html = html.replace(/"(\w+)\:(.+)"/g,
            "\"<span class='entity-name'>$1</span><span class='curl-assignment'>:</span>$2\"");
        // Highlight the -x instructions.
        html = html.replace(/\s(-\w)\s/g, " <span class='curl-flag'>$1</span> ");
        // Low-light the curly brackets.
        html = html.replace(/\{(\w+)\}/g,
            "<span class='var'><span class='var-bracket'>{</span>$1<span class='var-bracket'>}</span></span>");
        // Low-light the question mark, but keep it bold.
        html = html.replace(/(\?|&amp;)/g, "<span class='curl-question'>$1</span>");

        //$(this).html(html);
        this.setState( { html : html } );
    }
    componentWillMount(){
        this.highlightHtml(this.props.template );
    }
    componentWillReceiveProps(nextProps){
        let vals = nextProps.values;
        let html = this.props.template;
        if(vals){
            vals.forEach((node) => {
                if(node.val){
                    html = html.replace( "{" + node.key + "}", node.val )
                }
            });
        }
        this.setState( { wait : false } );
        this.highlightHtml(html);
    }
    render(){
        if( this.state.wait ){
            return ( <div className="curl">(Waiting for user input...)</div> );
        } else{
            return ( <div className="curl" dangerouslySetInnerHTML={ { __html : this.state.html } }/>)
        }
    }
}

HighlightedCurl.propTypes = {
    template : React.PropTypes.string.isRequired,
    values : React.PropTypes.array,
    wait : React.PropTypes.bool
};

export default class CurlWidget extends React.Component {
    constructor(props){
        super(props);
        this.processCurlTemplate( props.template );
        this.inputs = [];
        this.generateCurl = this.generateCurl.bind(this);
        this.resetCurl = this.resetCurl.bind(this);
        this.state = { curlValues : [] };
    }

    processCurlTemplate( template ){
        let vars = template.match(/{*[\w]*}/g);
        //Configure rows in the table - give each variable a row
        this.rows = [];
        for(let v of vars){
            let key = v.substring(1, v.length - 1 );
            this.rows.push({
                label : this.toHumanReadable(key),
                key : key,
                val : CURL_DEFAULTS[key],
                isOptional : CURL_OPTIONAL[key]
            })
        }
    }

    toHumanReadable( s ) {
        let parts = s.split(/(?=[A-Z])/);
        parts.forEach( (word, idx) => {
            parts[idx] = word.charAt(0).toUpperCase() + word.substring(1);
        });
        return parts.join(" ");
    }

    generateCurl(){
        let values = [];
        //iterate through form
        let $inputs = $(this.myTable).find('input,textarea');
        $inputs.each( (function() {
           values.push({
               key : $(this).attr('id'),
               val : $(this).val()
           })
        }));
        this.setState( { curlValues : values } )
    }
    resetCurl(){
        let $inputs = $(this.myTable).find('input,textarea');
        $inputs.each( function() {
            $(this).val('');
        });
        this.setState( { curlValues : [] })
    }

    render(){
        return (
            <div>
                <HighlightedCurl template={ this.props.template } />
                <br/>
                <p>To generate the cURL syntax for your specific API call, enter the appropriate values in the following widget and click the "Generate cURL Syntax" button.</p>
                <div>
                    <table className="name-description curl-table" ref={ (table) => { this.myTable = table ; } }>
                        <tbody>
                        { this.rows.map((row,i)  =>
                            <tr key={row.key + i}>
                                <td><b>{ row.label }</b> { row.isOptional ? <span className="flag">(Optional)</span> : '' } </td>
                                <td>
                                    { row.key == 'objectData' ?
                                        <textarea rows="8" id={row.key} /> :
                                        <input type="text" id={row.key} defaultValue={row.val}/>
                                    }
                                </td>
                            </tr>
                        )
                        }
                        <tr>
                            <td colSpan="2">
                                <button className="curl-btn curl-submit-btn" onClick={ this.generateCurl }>Generate cURL Syntax</button>
                                <button className="curl-btn curl-reset-btn" style={{ float : 'right'}} onClick={ this.resetCurl }>Clear Form</button>
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <p><b>cURL Call:</b></p>
                <HighlightedCurl template={this.props.template} values={ this.state.curlValues } wait={true}/>
            </div>
        );
    }
}

CurlWidget.propTypes = {
    template : React.PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./public/javascripts/react/components/curl.js